import _ from 'lodash';

/**
 * Splits a hyphenated range label into its parts, numbering them where possible. Returns the text in a single-element array when there is no hyphen, otherwise trims each part and converts it to a number when it parses, collapsing a one-part result to a bare value.
 *
 * @param text - Label to split.
 * @returns The parsed parts, a single part, or the original text wrapped in an array.
 */
// eslint-disable-next-line import/prefer-default-export
export const splitAndConvert = (text: string) => {
  if (!text.includes('-')) {
    return [text];
  }
  const parts = text.split('-').map((part) => {
    const num = parseInt(part.trim(), 10);
    return _.isNaN(num) ? part.trim() : num;
  });

  return parts.length === 1 ? parts[0] : parts;
};
